<template>
  <section class="sec-top-intro">
    <div class="box-top-slide">
      <div class="img-top-slide">
        <img src="@/assets/img/column/202405_01.jpg" class="only_pc" />
        <img src="@/assets/img/column/202405_01_sp.jpg" class="only_sp" />
      </div>
      <div class="img-top-slide_text">
        <h2 class="mb-0 text-right"><span>日焼け止めの下地はこう選ぶ！</span><br>おすすめ商品と選び方</h2>
      </div>
    </div>
  </section>

  <section class="column_content">
    <h2 class="mt-5 pt-5">紫外線対策、夏だけになっていませんか？<br>日焼け止めは一年中必要</h2>
    <div class="feature-row">
      <div class="feature-row_item_text feature-row_item_text_left w-50">
        <h3 class="mb-3"><small>あなたは大丈夫？</small><br>日焼け止めは、普通の日こそ忘れがち</h3>
        <p class="mb-3">もうすぐ夏本番。</p>
        <p class="mb-3">アウトドアや旅行など、お出かけが楽しい季節。</p>
        <p class="mb-3">一方で美肌を気にかけている方は紫外線が特に気になる時期でしょう。</p>
        <p class="mb-3">もちろんレジャータイムは日焼け止めが必須ですが</p>
        <p class="mb-3">日常の出勤時やお買い物の時などちょっとした時間の外出時も日焼け止めが必要です。</p>
        <p>そして、それは紫外線が強くなる夏場以外も同様！</p>
      </div>
      <div class="feature-row_item_image w-50">
        <img src="@/assets/img/column/202405_02.jpg">
      </div>
    </div>
    <div class="feature-row">
      <div class="feature-row_item_image w-50">
        <img src="@/assets/img/column/202405_03.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-50">
        <h3 class="mb-3"><small>美肌の大敵「紫外線」</small><br>日焼け止めが一年中必要な理由</h3>
        <p class="mb-3">スキンケアにとって重要な、日焼け対策。夏場以外のシーズンやレジャー以外の日頃も必要って知っていますか？</p>
        <p class="mb-3">もちろん美肌を目指す方はご存知かもしれませんが、改めて日焼け止めが一年中大切な必要性を知っておきましょう。</p>
        <p>ついつい、忘れてしまったり怠ってしまうと、美肌への道が遠くなってしまうかも！？</p>
      </div>
    </div>
    <div class="feature-row">
      <div class="feature-row_item_image w-25">
        <img src="@/assets/img/column/202405_04.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-75">
        <h3 class="mb-3">日焼けは、お肌のダメージ</h3>
        <p class="mb-3">日焼け止めが大切なことは知っているけれど、なぜ必要なのでしょうか？なんとなく「お肌を守る」と思っている方も多いと思いますが</p>
        <p class="mb-3"><strong>「日焼けしている＝肌がダメージを受けている」</strong></p>
        <p class="mb-3">これは火傷と同様に、肌が炎症を起こしている状態です。ではなぜ紫外線を浴びると日焼けするの？</p>
        <p class="mb-3">その理由は、紫外線をあびると身体が肌を守ろうとして「メラニン」を大量に作ります。過剰に生成されたメラニンが色素沈着をおこし、肌が黒くなったりシミやそばかすの原因になります。</p>
        <p>さらにこの状態が蓄積されていくとお肌の、たるみやシワの原因にもなってしまいます。</p>
      </div>
    </div>
    <div class="feature-row">
      <div class="feature-row_item_image w-25">
        <img src="@/assets/img/column/202405_05.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-75">
        <h3 class="mb-3">紫外線は曇りや雨、屋内にも降りそそいでくる！</h3>
        <p class="mb-3">日焼け止めを、日差しが気になる夏場はマストにしている方も多いと思いますが、紫外線は一年中降りそそいでいます。</p>
        <p class="mb-3">季節や時間帯によって変化や量は異なりますが、これは太陽が出ていない曇りや雨の日同様。</p>
        <p class="mb-3">さらに紫外線は、窓ガラスも突き抜けてしまうため屋内や屋外においても日焼け止めは必要ということです。</p>
        <p>そのため、日焼け止めは日常のちょっとしたお買い物や屋内でも、欠かすことができない大切なスキンケアなのです。</p>
      </div>
    </div>
    <div class="feature-row">
      <div class="feature-row_item_text feature-row_item_text_left w-50">
        <h3 class="mb-3"><small>ではどんな日焼け止めを選べばいい？</small><br>SPF値とPA値</h3>
        <p class="mb-3"><strong>SPF値</strong></p>
        <p class="mb-3">肌が赤くなる日焼け（サンバーン）やシミ、そばかすの原因になりやすく肌に炎症を起こさせる紫外線「UVB」に対する防止効果を示すもの。</p>
        <p class="mb-3">2～50の数値で効果が示され、最大値の50を超える場合は「50+」と表記されるます。</p>
        <p class="mb-3"><strong>PA値</strong></p>
        <p class="mb-3">日差しを浴びた後に肌をすぐに黒くしたり、シミ、しわ、たるみなどや色素沈着の原因となるメラニンの生成を促してしまう紫外線「UVA」に対する防止効果を示すもの。</p>
        <p>「PA+」〜「PA++++」の4段階で表記され、+の数が多いほど効果が高くなります。</p>
      </div>
      <div class="feature-row_item_image w-50">
        <img src="@/assets/img/column/202405_06.jpg">
      </div>
    </div>
    <div class="feature-row">
      <div class="feature-row_item_image w-50">
        <img src="@/assets/img/column/202405_07.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-50">
        <h3 class="mb-3"><small>数値が高ければいいわけではない！</small><br>おすすめの日焼け止めの選び方</h3>
        <p class="mb-3">SPF値とPA値が示す意味については、知ってもらえたかもしれません。</p>
        <p class="mb-3">では実際毎日必要な日焼け止めを、どうやって選べばいいのか気になりますよね。</p>
        <p class="mb-3">多くの方は「とりあえず数値が高いものを選べば安心なのでは・・」と思う方も少なくありません。</p>
        <p class="mb-3">日焼け止めは、ご自身やシチュエーションに合わせて選ぶことが大切です。</p>
        <p class="mb-3"><strong>おすすめの日焼け止めの選び方</strong></p>
        <p class="mb-3">・日常生活でのお散歩やお買い物、屋内で過ごす日など：SPF10〜20、PA＋＋</p>
        <p class="mb-3">・屋外での軽いスポーツやレジャーなど：SPF30以上、PA＋＋＋</p>
        <p>・炎天下でのレジャーやお出かけ、リゾート地でのマリンスポーツなど：SPF50以上、PA＋＋＋＋</p>
      </div>
    </div>

    <div class="layer_01  mt-5 py-5">
      <img src="@/assets/img/column/layer-bg_01.jpg">
      <div class="layer-text">
        <p class="mb-3 fs-2">美肌は一日にしてならず</p>
        <p class="mb-3">シーンにあった日焼け止めを駆使して、明日の美肌を目指しましょう。</p>
        <p class="mb-3">ここからはマナビス化粧品おすすめのUVケアアイテムをご紹介。</p>
        <p>化粧下地にもなる優れモノから、レジャーにも安心な強力タイプまで、ご自身にあった一品を</p>
      </div>
    </div>
    
    <div class="mt-5">
      <img src="@/assets/img/column/202405_08.jpg" class="only_pc" />
      <img src="@/assets/img/column/202405_08_sp.jpg" class="only_sp" />
    </div>

    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">PROTECTION<br>UVミルク</h3>
        <p class="mb-3">¥5,500</p>
        <p class="mb-3">日やけ止め用乳液 30g</p>
        <p class="mb-3">SPF40 PA++++</p>
        <p class="mb-3">紫外線防止効果の高く、ヒアルロン酸成分配合の日やけ止め用乳液。</p>
        <p class="mb-3">クリアで白浮きせず、なめらかな仕上がり。<br>レジャーにもおすすめの、顔・からだ用。</p>
        <p class="mb-3">3つの機能を兼ね備えた、万能な日やけ止め用乳液。</p>
        <p>・紫外線、近赤外線防止効果<br>・肌へやさしく、洗顔料で洗い流せる<br>・心地よい使用感。なめらかで伸びやすく、透明感のある仕上がり</p>
        <div class="mt-5">
          <router-link to="/products" class="btn">
            商品一覧へ
          </router-link>
        </div>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/protection_uvmilk.jpg">
      </div>
    </div>
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/protection_skincover_advance.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">PROTECTION<br>スキンカバー アドバンス</h3>
        <p class="mb-3">¥5,500</p>
        <p class="mb-3">日中用化粧液 30mL</p>
        <p class="mb-3">SPF15 PA++</p>
        <p class="mb-3">うるおいを与えながら、紫外線B波・A波、近赤外線から肌を守ります。</p>
        <p class="mb-3">するする伸びて、みずみずしく。</p>
        <p class="mb-3">健康的な色味で、素肌よりも美しい素肌感へ。</p>
        <p class="mb-3">UVミルクの後に重ねづけしても、厚塗り感のない自然な仕上がりです。</p>
        <p class="mb-3">メイクアップ下地としても、おすすめ。</p>
        <p>メイクをせず、スキンカバー アドバンスのみでしたら、薬用スキンウォッシュで洗い流せます。</p>
        <div class="mt-5">
          <router-link to="/products" class="btn">
            商品一覧へ
          </router-link>
        </div>
      </div>
    </div>
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">PROTECTION<br>スキンカバー ナチュラル</h3>
        <p class="mb-3">¥5,500</p>
        <p class="mb-3">日中用化粧液 30g</p>
        <p class="mb-3">SPF13 PA++</p>
        <p class="mb-3">うるおいを与えながら、紫外線B波・A波、近赤外線から肌を守ります。</p>
        <p class="mb-3">するする伸びて、ややしっとり。</p>
        <p class="mb-3">どんな肌の色にもなじみやすく、素肌よりも美しい素肌感へ。</p>
        <p class="mb-3">UVミルクの後に重ねづけしても、厚塗り感のない自然な仕上がりです。</p>
        <p class="mb-3">メイクアップ下地としても、おすすめ。</p>
        <p>メイクをせず、スキンカバー ナチュラルのみでしたら、薬用スキンウォッシュで洗い流せます。</p>
        <div class="mt-5">
          <router-link to="/products" class="btn">
            商品一覧へ
          </router-link>
        </div>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/protection_skincover_natural.jpg">
      </div>
    </div>
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/protection_skincover_white.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">PROTECTION<br>スキンカバー ホワイト</h3>
        <p class="mb-3">¥5,500</p>
        <p class="mb-3">日中用化粧液 30g</p>
        <p class="mb-3">SPF18 PA++</p>
        <p class="mb-3">うるおいを与えながら、紫外線B波・A波、近赤外線から肌を守ります。</p>
        <p class="mb-3">するする伸びて、しっとり。</p>
        <p class="mb-3">色白の肌、ワントーン明るく見せたい肌へ。</p>
        <p class="mb-3">UVミルクの後に重ねづけしても、厚塗り感のない自然な仕上がりです。</p>
        <p class="mb-3">メイクアップ下地としても、おすすめ。</p>
        <p>メイクをせず、スキンカバー ホワイトのみでしたら、薬用スキンウォッシュで洗い流せます。</p>
        <div class="mt-5">
          <router-link to="/products" class="btn">
            商品一覧へ
          </router-link>
        </div>
      </div>
    </div>
   
    <div class="layer_02">
      <img src="@/assets/img/column/202405_09.jpg">
      <div class="layer-text">
        <div class="layer-text-inner">
          <h2 class="mb-3 text-left"><span>マナビス化粧品</span><br>プロテクションシリーズ</h2>
          <h3>紫外線・近赤外線から素肌を守るデイケア</h3>
        </div>
      </div>
    </div>

    <div class="text-center pt-5 mt-5">
      <p class="mb-3">美肌の大敵は、表皮の奥まで達する紫外線B波（UVB）、</p>
      <p class="mb-3">その下の真皮にまで達する紫外線A波（UVA）、</p>
      <p class="mb-3">さらに下層の皮下組織へ達する近赤外線、そして乾燥。</p>
      <p class="mb-3">マナビス化粧品のデイケアアイテムは、</p>
      <p class="mb-3">そのすべてに対策できるよう設計されています。</p>
      <p class="mb-3">シーン、使用感、仕上がりによって選べる4タイプです。</p>
      <p class="mb-3">紫外線吸収剤は不使用。</p>
      <p>紫外線散乱剤を使用したマイルドな処方です。</p>
    </div>
    
    <h2 class="mt-5 pt-5">PROTECTIONシリーズ</h2>
    <div class="feature-row feature-row_product_list">
      <div class="feature-row_product_item">
        <router-link to="/products">
            <img src="@/assets/img/column/protection_skincover_advance.jpg">
            <div class="feature-row_product_detail text-center">
              <div class="feature-row_product_title">スキンカバー アドバンス</div>
              <div class="feature-row_product_cate">PROTECTION</div>
              <div class="feature-row_product_price">¥5,500</div>
            </div>
        </router-link>
      </div>
      <div class="feature-row_product_item">
        <router-link to="/products">
            <img src="@/assets/img/column/protection_uvmilk.jpg">
            <div class="feature-row_product_detail text-center">
              <div class="feature-row_product_title">UVミルク</div>
              <div class="feature-row_product_cate">PROTECTION</div>
              <div class="feature-row_product_price">¥5,500</div>
            </div>
        </router-link>
      </div>
      <div class="feature-row_product_item">
        <router-link to="/products">
            <img src="@/assets/img/column/protection_skincover_white.jpg">
            <div class="feature-row_product_detail text-center">
              <div class="feature-row_product_title">スキンカバー ホワイト</div>
              <div class="feature-row_product_cate">PROTECTION</div>
              <div class="feature-row_product_price">¥5,500</div>
            </div>
        </router-link>
      </div>
      <div class="feature-row_product_item">
        <router-link to="/products">
            <img src="@/assets/img/column/protection_skincover_natural.jpg">
            <div class="feature-row_product_detail text-center">
              <div class="feature-row_product_title">スキンカバー ナチュラル</div>
              <div class="feature-row_product_cate">PROTECTION</div>
              <div class="feature-row_product_price">¥5,500</div>
            </div>
        </router-link>
      </div>
    </div>
  </section>


  <!-- トップに戻るボタン -->
  <button id="page-top" class="btn" v-on:click="scrollTop">
    TOP
  </button>

</template>

<style scoped>
.column_content h2,.column_content h3 {
  font-weight: 500 !important;
}
small {
  font-size: .7em;
}

.feature-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 50px;
}
.feature-row_item_image img {
  width: 100%;
}
.feature-row_item_text h3 {
  font-size: 1.25em;
}

button#page-top {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 100;
}


.layer_01 {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url('../../assets/img/column/layer-bg_01.jpg');
  background-size: cover;
  background-position: center;
  min-height: 500px; /* 最小高さを設定しておくと、極端に小さくなるのを防げます */
  padding: 20px; /* テキストと画像の端の間に余白を設定 */
}
.layer_01 img {
  display: none; /* 画像は背景として使用するので非表示にします */
}
.layer_01 .layer-text {
  padding: 10px;
  text-align: center;
  max-width: 90%; /* 文字が画像からはみ出さないように最大幅を設定 */
  word-wrap: break-word; /* 長い単語が折り返されるようにする */
  color: #424242;
  font-weight: 500;
}
.layer_01 .layer-text .fs-2 {
  font-size: 2em;
}

.feature-row_product_list {
  align-items: inherit;
}
.feature-row_product_item {
  width: 25%;
  padding: 5px;
  text-align: center;
}
.feature-row_product_detail {
  color: #333;
}
.feature-row_product_cate {
  font-size: .8em;
  color: #6b6b67;
  opacity: .65;
}

.feature-row_voice_list {
  align-items: baseline;
}
.feature-row_voice_list path.a {
  fill: none;
  stroke: #000;
  stroke-width: 2px;
}
.feature-row_voice_list .icon svg {
  width: 70px;
}
.feature-row_voice_list .feature-row_voice_item {
  width: 33%;
  padding: 5px;
  text-align: center;
}

.box-top-slide {
  position: relative;
}
.img-top-slide_text {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 30px;
}
.img-top-slide_text h2 {
  font-size: 2em;
  font-weight: 500 !important;
}
.img-top-slide_text h2 span {
  font-size: .6em;
}

.layer_02 .layer-text {
  background-color: #cacaca;
  padding: 10px;
}
.layer_02 .layer-text .layer-text-inner {
  background-color: #fff;
  padding: 15px;
}
.layer_02 .layer-text .layer-text-inner h2 span {
  font-size: .6em;
}
@media screen and (min-width: 991px) {
    .layer_02 {
      position: relative;
      display: flex;
      align-items: baseline;
      background-image: url('../../assets/img/column/202405_09.jpg');
      background-size: cover;
      min-height: 600px; /* 最小高さを設定しておくと、極端に小さくなるのを防げます */
      padding: 60px; /* テキストと画像の端の間に余白を設定 */
      justify-content: end;
    }
    .layer_02 img {
      display: none; /* 画像は背景として使用するので非表示にします */
    }
    .layer_02 .layer-text {
      padding: 15px;
      max-width: 90%; /* 文字が画像からはみ出さないように最大幅を設定 */
      word-wrap: break-word; /* 長い単語が折り返されるようにする */
      color: #424242;
      background-color: #fff;
    }
}
@media screen and (max-width: 699px) {
   .img-top-slide_text {
      top: 40%;
      left: 15px;
      right: 15px;
    }
    .img-top-slide_text h2 {
      font-size: inherit;
    }
    .img-top-slide_text h2 span {
      font-size: .8em;
    }
}
@media screen and (min-width: 769px) {
   .feature-row_item_text_right {
    padding-left: 60px;
   }
   .feature-row_item_text_left {
    padding-right: 60px;
   }
   .w-40 {
    width: 40%;
   }
   .w-60 {
    width: 60%;
   }

}
@media screen and (min-width: 1px) and (max-width: 768px) {
  .column_content h2 {
    margin-bottom: 40px;
  }
  .feature-row {
    flex-direction: column;
  }
  .feature-row_item_image {
    order: 1;
    margin-bottom: 15px;
  }
  .feature-row_item_text {
    order: 2;
  }
  .feature-row_voice_item, .feature-row_product_item {
      width: 100% !important;
  }
  .w-50, .w-25, .w-75 {
    width: 100% !important;
  }
  .layer-text {
    font-size: .8em;
  }
  .layer_01 .layer-text .fs-2 {
    font-size: 1.5em;
  }
}
</style>

<script>
import $ from "jquery";

$(function() {
 var topBtn = $('#page-top');    
 topBtn.hide();
 //スクロールが500に達したらボタン表示
 $(window).scroll(function () {
 if ($(this).scrollTop() > 500) {
 topBtn.fadeIn();
        } else {
 topBtn.fadeOut();
        }
    });
    
});

// ページ内リンク
export default{
  data: () => {
    return {isActive: []}
  },
  mounted (){
    window.scroll(0, 0);
    for(let i = 0; i < 2; i++) {
      this.isActive[i] = false
    }
  },
  methods: {
    scrollToAnchorPoint(refName) {
      const el = this.$refs[refName]
      el.scrollIntoView({ behavior: 'smooth'})
    },
    openInfo(ref) {
      console.log(ref)
      this.isActive[ref] = true
      console.log(this.isActive[ref])
    },
    closeInfo(ref) {
      console.log(ref)
      this.isActive[ref] = false
      console.log(this.isActive[ref])
    },
    scrollTop(){
      window.scrollTo({
      top: 0,
      behavior: "smooth"
      })
    }
  }
}

</script>